import React, { useState, useEffect, useMemo } from 'react';
import { Menu } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import cargoFieldOwnerSideMenus from '@/constants/cargo-field-owner-side-menus';
import { DICT_IGNORE_PATH } from '@/constants';
import { getAllowedMenus, getAllowedMenusByCode } from '@/store/allowed-menus';
import { filterDisabledRoutes, getLinkByPath } from '@/store/menus.utils';
import useSlideMenuCollapsedChange from '@/hooks/useSlideMenuCollapsedChange';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import utils, { getQuery } from '@/common/utils';
import ComponentLog from '@/components/component-log';
import { connect } from 'react-redux';
import { getGlobalGuideList } from '@/store/auto-guide';
import { useHistory, matchPath } from 'react-router-dom';
import { pushSideMenusIn } from '@/pages/route-config-inducc';
import './index.less';

const { SubMenu } = Menu;

const subMenuItemStyle = {
  paddingLeft: '8px',
};

// 过滤掉 {menuId: 1, menus: []} 这样的，没有文件的文件夹不用展示
function filterEmptySubmenu(sideMenus = []) {
  return sideMenus.filter((item) => !item.menus || item.menus.length !== 0);
}

function NewSideMenu(props) {
  const history = useHistory();
  const [selectedKeys, setSelectKeys] = useState([]);
  const menus = useSelector((state) => {
    return state.menus.filter((item) => !DICT_IGNORE_PATH[item.path]);
  });
  const [outestSideMenuClasename, _, toggleSidemenuCollapsedSatus] = useSlideMenuCollapsedChange(
    'outest-side-menu-collapsed',
    'outest-side-menu-uncollapsed'
  );

  const _sideMenus = useMemo(() => {
    // 为什么这个一直在变
    return filterEmptySubmenu(
      filterDisabledRoutes(
        pushSideMenusIn(cargoFieldOwnerSideMenus, 0, props.duccRoutes),
        getAllowedMenus(),
        getAllowedMenusByCode(),
        false
      )
    );
    // eslint-disable-next-line
  }, [menus]);

  useEffect(() => {
    // 找选中的菜单
    let effectiveItem = [];
    _sideMenus.forEach((parentMenu) => {
      if (!parentMenu.menus) {
        effectiveItem.push(parentMenu);
      } else {
        parentMenu.menus.map((childMenu) => {
          effectiveItem.push(childMenu);
        });
      }
    });
    let matchItems = [];
    effectiveItem.forEach((childItem) => {
      if (matchPath(props.location.pathname, { path: childItem.path, exact: false, strict: false }))
        matchItems.push(childItem);
    });

    if (matchItems.length >= 2) {
      matchItems.sort((a, b) => b.path.length - a.path.length);
    }

    setSelectKeys(() => {
      if (!matchItems[0]) return [];
      if (props.location.pathname !== '/' && matchItems[0].path == '/') {
        return [];
      } else {
        return [String(matchItems[0].path)];
      }
    });

    // eslint-disable-next-line
  }, [props.location.pathname]);

  // 根据路由找到最匹配的subMenu，然后展开他
  function findOpenSubMenuKey() {
    const getSubMenus = _sideMenus.filter((ele) => !!ele.menus);
    let getOpenItems = [];
    getSubMenus.map((item) => {
      getOpenItems.push(String(item.path));
    });
    return getOpenItems;
  }

  const outestSideClassnames = classnames('outest-side outest-side-menu-2', outestSideMenuClasename);

  /**
   * 渲染侧边栏链接
   *
   * @param {{
   *  path: string
   *  title: string
   *  target: _blank | undefined 是否新开tab
   * }} menuConfigItem
   * @param {*} parentMenuConfigItem
   */
  function renderLink(menuConfigItem, parentMenuConfigItem) {
    const parentPath = parentMenuConfigItem ? parentMenuConfigItem.path : '';
    const { getlog } = menuConfigItem;
    const clstag = typeof getlog === 'function' ? getlog() : null;

    const path = getLinkByPath(menuConfigItem.getLink, {
      search: '',
      relativePath: menuConfigItem.path,
      parentPath,
      path: menuConfigItem.path,
    });

    const indentStyle = parentMenuConfigItem ? subMenuItemStyle : undefined;

    if (menuConfigItem.target) {
      return (
        <ComponentLog>
          <a
            clstag={clstag}
            style={indentStyle}
            onClick={() => hrefAndGetNewIcon(menuConfigItem.menuId, 'href', path, menuConfigItem.target)}
            className="sub-menu-item-link"
          >
            {menuConfigItem.title}
            {renderIcon(menuConfigItem)}
          </a>
        </ComponentLog>
      );
    } else {
      return (
        <ComponentLog>
          <Link
            style={indentStyle}
            to={path}
            clstag={clstag}
            onClick={() => hrefAndGetNewIcon(menuConfigItem.menuId, 'to')}
            className="sub-menu-item-link"
          >
            {menuConfigItem.title}
            {renderIcon(menuConfigItem)}
          </Link>
        </ComponentLog>
      );
    }
  }

  function hrefAndGetNewIcon(menuId, type, path, target) {
    if (type == 'href') {
      if (path) {
        window.open(path, target, 'noopener, noreferrer');
      }
    } else {
      if (path) {
        history.push(path);
      }
    }
  }

  function renderIcon(item, addClass) {
    let currIdFlag = '';
    let url = '';
    const matchList = props.list.filter((obj) => obj.location.split('-').slice(-1)[0] == item.menuId);
    if (matchList && matchList.length) {
      const matchItem = matchList[0];
      if (matchItem.type == 1) {
        currIdFlag = 'FUNC';
        url = '//img30.360buyimg.com/pop/jfs/t1/150315/19/21909/1858/620dfc9cEb4a7628d/6fa98dcaab6ce312.png';
      }
      if (matchItem.type == 3) {
        currIdFlag = 'FUNC';
        url = matchItem.imageUrl;
      }
    }
    if (currIdFlag === 'FUNC') {
      return (
        <img
          src={url}
          className={classnames('sub-menu-item-icon', addClass, {
            'nav-sec-item-title-icon-custom': matchList[0].type == 3,
          })}
        />
      );
    }
  }

  function logUp(item) {
    const { getlog, customLog } = item;
    const clstag = typeof getlog === 'function' ? getlog() : null;
    const log = typeof customLog === 'function' ? customLog : () => {};
    return { log, clstag };
  }

  // 嵌入营销阵地
  if (getQuery('origin') === 'Babel') {
    return null;
  }
  return (
    <>
      <div style={{ height: '12px', backgroundColor: '#F3F3F5' }}></div>
      <div className={outestSideClassnames}>
        <Menu
          defaultOpenKeys={findOpenSubMenuKey()}
          id="side-bar-scroll"
          className="hidden-scroll-bar"
          inlineIndent={11}
          selectedKeys={selectedKeys}
          mode="inline"
          theme="light"
        >
          {_sideMenus.map((item) => {
            const iconsProps = item.Icon ? { icon: <item.Icon /> } : {};
            if (item.menus) {
              return (
                <SubMenu
                  style={{ marginTop: '16px', marginLeft: '4px' }}
                  data-guide={item.path}
                  data-new={`id-${item.menuId}`}
                  {...iconsProps}
                  key={String(item.path)}
                  title={
                    <ComponentLog>
                      <span clstag={logUp(item).clstag} onClick={logUp(item).log}>
                        {item.title}
                        {renderIcon(item, 'first-level')}
                      </span>
                    </ComponentLog>
                  }
                >
                  {item.menus.map((childItem, index) => (
                    <Menu.Item
                      key={String(childItem.path)}
                      onClick={logUp(childItem).log}
                      data-new={`id-${childItem.menuId}`}
                      data-guide={childItem.path}
                    >
                      <ComponentLog clstag={logUp(childItem).clstag}>
                        <span>{renderLink(childItem, item)}</span>
                      </ComponentLog>
                    </Menu.Item>
                  ))}
                </SubMenu>
              );
            } else {
              return (
                <Menu.Item
                  className="new-menu-submenu-title"
                  style={{ marginTop: '16px', marginLeft: '8px' }}
                  onClick={logUp(item).log}
                  data-new={`id-${item.menuId}`}
                  data-guide={item.path}
                  {...iconsProps}
                  key={String(item.path)}
                >
                  {renderLink(item)}
                </Menu.Item>
              );
            }
          })}
        </Menu>
        <div className="btn-collapsed-l">
          <div className="btn-collapsed-close" onClick={toggleSidemenuCollapsedSatus}>
            <LeftOutlined />
          </div>
        </div>
        <div className="btn-collapsed-r">
          <div className="btn-collapsed-open" onClick={toggleSidemenuCollapsedSatus}>
            <img
              style={{ width: '18px' }}
              src={utils.resizeImg(
                '//img30.360buyimg.com/pop/jfs/t1/173926/17/25119/1588/61d933b4E392b5ce7/a4d9013c378a83b9.png',
                60
              )}
            />
            <RightOutlined />
          </div>
        </div>
      </div>
    </>
  );
}

const _SlideMenu = connect(
  (state) => {
    return {
      list: state.globalGuide.list,
      duccRoutes: state.duccRoutes,
    };
  },
  { getGlobalGuideList }
)(NewSideMenu);

export default withRouter(_SlideMenu);
